import {ToastOptions} from 'ng2-toastr';

export class SCAdminToastOptions extends ToastOptions {
  animate = 'flyRight'; // you can override any options available
  newestOnTop = false;
  showCloseButton = true;
  positionClass = 'toast-top-center';
  maxShown = 2;
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/core/SCAdminToastOptions.ts